import { AppState } from '@/vuex/store';
import Customer from '@/customer/models/Customer';
import CustomerProp from '@/customer/models/CustomerProp';
import customerFilter from '@/customer/models/CustomerFilter';
import customerQuery from '@/customer/models/CustomerQuery';

export default {
  SET_SEARCH_FIELDS: (state: AppState, fields: string[]) => {
    state.customerState.searchFields = fields;
  },
  SHOW_CUSTOMER_DETAIL: (state: AppState, customer: Customer) => {
    state.customerState.showCustomerDetail = true;
    state.customerState.currentCustomer = customer;
  },
  SHOW_CUSTOMER_SCORE_DETAIL: (state: AppState, customer: Customer) => {
    state.customerState.detailSelectedScore = true;
    state.customerState.showCustomerDetail = true;
    state.customerState.currentCustomer = customer;
  },
  HIDE_CUSTOMER_DETAIL: (state: AppState) => {
    state.customerState.showCustomerDetail = false;
    state.customerState.detailSelectedScore = false;
  },
  SHOW_CUSTOMER_EXPORT: (state: AppState, customer: Customer) => {
    state.customerState.showCustomerExport = true;
  },
  HIDE_CUSTOMER_EXPORT: (state: AppState, customer: Customer) => {
    state.customerState.showCustomerExport = false;
  },
  SHOW_CUSTOMER_ANALYZE: (state: AppState, customer: Customer) => {
    state.customerState.showCustomerAnalyze = true;
  },
  HIDE_CUSTOMER_ANALYZE: (state: AppState, customer: Customer) => {
    state.customerState.showCustomerAnalyze = false;
  },
  SET_CUSTOMER_PROPS: (state: AppState, props: CustomerProp[]) => {
    state.customerState.props = props;
  },
  UPDATE_CUSTOMER_DISPLAY_FIELDS: (state: AppState, fields: string[]) => {
    state.customerState.displayFields = fields;
  },
  CUSTOMER_TABLE_REFRESH: (state: AppState) => {
    state.customerState.customerList.refreshCounter++;
  },
  CUSTOMER_TABLE_RELOAD: (state: AppState) => {
    state.customerState.customerList.refreshCounter++;
  },
  UPDATE_CUSTOMER_LIST: (state: AppState, params: any) => {
    state.customerState.customerList.data = params.customers;
    state.customerState.customerList.total = params.total;
  },
  INIT_CUSTOMER_FILTER: (state: AppState) => {
    state.customerState.customerFilter = JSON.parse(JSON.stringify(customerFilter));
  },
  UPDATE_CUSTOMER_QUERY: (state: AppState, params: any) => {
    state.customerState.customerQuery[params.key] = params.value;
  },
  DELETE_CUSTOMER_QUERY_SUBSCRIBE: (state: AppState) => {
    state.customerState.customerQuery.subscribe = undefined;
  },
  INIT_CUSTOMER_QUERY: (state: AppState) => {
    state.customerState.customerQuery = JSON.parse(JSON.stringify(customerQuery));
  },
  SET_CUSTOMER_QUERY: (state: AppState, query: any) => {
    state.customerState.customerQuery = query;
  },
  SET_CUSTOMER_REMAKRS: (state: AppState, remarks: string[]) => {
    state.customerState.currentCustomer!.remarks = remarks;
  },
  SHOW_CHAT: (state: AppState, openid: string) => {
    state.customerState.showChat = true;
    state.customerState.chatOpenid = openid;
  },
  HIDE_CHAT: (state: AppState) => {
    state.customerState.showChat = false;
    state.customerState.chatOpenid = undefined;
  },
  APPEND_CUSTOMER_GROUP: (state: AppState, params: any) => {
    state.customerState.customerList.data.forEach((c: Customer) => {
      if (params.openids.includes(c.openid) &&
          c.groups.includes(params.groupId)) {
        c.groups.push(params.groupId);
      }
    });
  },
  DELETE_CUSTOMER_GROUP: (state: AppState, params: any) => {
    state.customerState.customerList.data.forEach((c: Customer) => {
      if (params.openids.includes(c.openid) &&
          c.groups.includes(params.groupId)) {
        for (let i = 0; i < c.groups.length; i++) {
          if (c.groups[i] === parseInt(params.groupId)) {
            c.groups.splice(i, 1);
          }
        }
      }
    });
  },
  UPDATE_DURING_FIRST_SYNC: (state: AppState, params: any) => {
    state.customerState.duringFirstSync = params.status;
    state.customerState.syncPercent = params.percent || 0;
  },
};
